<div class="pv-image-move-sample-picker-dialog pv-view-component" *ngIf="state$ | async as state">

    <div mat-dialog-title class="dialog-header">
        <h2 class="dialog-title">Choose a different sample</h2>
        <button mat-icon-button type="button" (click)="cancel()" matTooltip="Cancel">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content class="dialog-content">
      <div class="view-body">

        <form pv-view-sidebar class="pv-form single-column dense p-12 sample-picker-form" [formGroup]="queryFormGroup">
            <div class="search-group pb-sm">
                <mat-form-field appearance="outline">
                    <mat-label>
                        <mat-icon>search</mat-icon> Search Samples
                    </mat-label>
                    <input type="text" matInput formControlName="search"
                        placeholder="Enter sample code or label">
                </mat-form-field>

                <button mat-icon-button type="button" color="warn" matTooltip="Clear Filters"
                        (click)="resetFilter()">
                    <mat-icon>filter_alt_off</mat-icon>
                </button>
            </div>

            <mat-form-field appearance="fill">
                <mat-label>
                    <mat-icon svgIcon="common:flat_scion"></mat-icon>
                    <span>Filter Scion Cultivar(s)</span>
                </mat-label>
                <pv-cultivar-autocomplete-chips formControlName="scionCultivars"
                                                [orgKey]="state.orgKey">
                </pv-cultivar-autocomplete-chips>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>
                    <mat-icon>place</mat-icon>
                    <span>Filter Location(s)</span>
                </mat-label>
                <pv-site-autocomplete-chips formControlName="sites"
                                            [orgKey]="state.orgKey">
                </pv-site-autocomplete-chips>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>Filter Crop</mat-label>
                <mat-select formControlName="scionCropId" multiple>
                    <mat-option *ngFor="let crop of cropOptions" [value]="crop.id">
                        <mat-icon [svgIcon]="'common:' + crop.id"></mat-icon>
                        <span>{{ crop.label }}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="flex-row">
                <mat-form-field appearance="fill" class="col-100">
                    <input formControlName="startEvalPeriod" matInput [matDatepicker]="startEvalPeriodPicker" placeholder="Choose a start date">
                    <mat-label>Evaluation Period Start</mat-label>
                    <mat-hint>Filter Samples with Evaluations from this date</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="startEvalPeriodPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startEvalPeriodPicker></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="flex-row">
                <mat-form-field appearance="fill" class="col-100">
                    <input formControlName="endEvalPeriod" matInput [matDatepicker]="endEvalPeriodPicker" placeholder="Choose an end date">
                    <mat-label>Evaluation Period End</mat-label>
                    <mat-hint>Filter Samples with Evaluations before this date</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="endEvalPeriodPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endEvalPeriodPicker></mat-datepicker>
                </mat-form-field>
            </div>
        </form>

        <div pv-view-body class="sample-picker-body" [ngSwitch]="state.status">

            <!--* STATUS: LOADING -->
            <pv-view-loader *ngSwitchCase="'LOADING'" message="Loading samples..."></pv-view-loader>

            <!--* STATUS: EMPTY -->
            <pv-view-message *ngSwitchCase="'EMPTY'"
                             heading="No results"
                             message="The current filters does not match any Samples."
                             icon="error">
                <button mat-raised-button color="accent"
                        pvMessageAction
                        (click)="resetFilter()">
                    Reset Filters
                </button>
            </pv-view-message>

            <!--* STATUS: OK -->
            <ng-container *ngSwitchCase="'OK'">
                <div class="sample-grid">
                    <ng-container *ngFor="let sample of state.data">
                        <pv-sample-card
                            [sample]="sample"
                            [isActive]="selectedSampleKey === sample.key"
                            (click)="selectSample(sample)">
                        </pv-sample-card>
                    </ng-container>
                </div>
            </ng-container>

            <!--* STATUS: ERROR / DEFAULT -->
            <pv-view-message *ngSwitchDefault [heading]="state.status | descStatusTitle"
                             [message]="state.status | descStatusMessage:'Sample'" icon="error">
            </pv-view-message>
        </div>

      </div>
    </div>

    <div class="dialog-footer pv-table-footer">

        <label class="mat-caption mr-12" for="sample_picker_sort">Sort</label>
        <mat-select [formControl]="columnControl"
                    id="sample_picker_sort"
                    class="sample-picker-sort-select">
            <mat-option *ngFor="let opt of state.sortOptions" [value]="opt.id">{{ opt.label }}
            </mat-option>
        </mat-select>
        <button type="button" class="ml-12" mat-icon-button (click)="toggleSortOrder($event)" matTooltip="Change Sort Direction">
            <mat-icon
                      [svgIcon]="orderControl.value === 'asc' ? 'fa:solid-sort-alpha-up' : 'fa:solid-sort-alpha-down'">
            </mat-icon>
        </button>

        <mat-paginator [length]="state.total"
                       [pageSize]="state.page.size"
                       [pageIndex]="state.page.index"
                       (page)="paginate($event)"
                       [pageSizeOptions]="[20,50,100]">
        </mat-paginator>
    </div>

    <div mat-dialog-actions align="end">
        <button mat-button type="button" (click)="cancel()">Cancel</button>
        <button mat-flat-button color="primary" type="button" [disabled]="!selectedSampleKey" (click)="select()">Select</button>
    </div>

</div>
